import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18n';

import { actions } from 'Actions/notificationTray';
import DotsLoader from 'Components/Base/DotsLoader';

const i18nOpts = { scope: 'notifications' };

class Notification extends Component {
  constructor(props) {
    super(props);

    this.handleMarkAsRead = this.handleMarkAsRead.bind(this);
    this.handleMarkAsUnread = this.handleMarkAsUnread.bind(this);
    this.markAsReadAndPassthrough = this.markAsReadAndPassthrough.bind(this);
  }

  markAsReadAndPassthrough(event) {
    event.preventDefault();
    const destination = event.currentTarget.href;
    if (this.props.isUnread) {
      this.props.markAsRead(this.props.id);
    }
    window.location.assign(destination);
  }

  handleMarkAsRead(event) {
    event.preventDefault();
    this.props.markAsRead(this.props.id);
  }

  handleMarkAsUnread(event) {
    event.preventDefault();
    this.props.markAsUnread(this.props.id);
  }

  renderStatusToggle() {
    if (this.props.isLoading) {
      return (
        <div className="notification__status-loader">
          <DotsLoader />
        </div>
      );
    }

    if (this.props.isUnread) {
      return (
        <button
          className="notification__mark-as-read"
          onClick={this.handleMarkAsRead}
          data-test="markAsRead"
        >
          {t('mark_as_read', i18nOpts)}
        </button>
      );
    }

    return (
      <button
        className="notification__mark-as-unread"
        onClick={this.handleMarkAsUnread}
        data-test="markAsUnread"
      >
        {t('mark_as_unread', i18nOpts)}
      </button>
    );
  }

  markupContent() {
    return { __html: this.props.body };
  }

  render() {
    const notificationClass = this.props.isUnread ? 'notification' : 'notification notification--read';

    return (
      <li className={notificationClass}>
        <a href={this.props.link} onClick={this.markAsReadAndPassthrough} className="notification__link">
          <div className="notification__content">
            <div className="notification__content-text" dangerouslySetInnerHTML={this.markupContent()} />
          </div>
        </a>
        <div className="notification__footer">
          <span className="notification__time">{this.props.timestamp}</span>
          {this.renderStatusToggle()}
        </div>
      </li>
    );
  }
}

Notification.propTypes = {
  body: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  link: PropTypes.string.isRequired,
  markAsRead: PropTypes.func.isRequired,
  markAsUnread: PropTypes.func.isRequired,
  timestamp: PropTypes.string.isRequired,
  isUnread: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.notificationTray.loadingNotificationIds.includes(ownProps.id),
});

const mapDispatchToProps = (dispatch) => ({
  markAsRead: (id) => dispatch(actions.markAsRead(id)),
  markAsUnread: (id) => dispatch(actions.markAsUnread(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
